export default __webpack_public_path__ + "static/media/bg.33f9ddc5.png";